/* eslint-disable vue/valid-template-root */ /* eslint-disable vue/valid-v-for */
<template>

  <div>
    <button @click="changeLocale()" class="locale-switcher ml-2 p-2">
      <flag :iso="currentFlag" v-bind:squared="false" />
      <span class="ml-2">{{ currentLang }}</span>
    </button>
  </div>
</template>

<script>
import i18n from '@/plugins/i18n';
import getUserCountry from 'js-user-country'

export default {
  components: {},
  data() {
    return {
      currentLang: 'es',
      currentFlag: getUserCountry().id,
      languages: [
        { flag: 'us', language: 'en', title: 'English' },
        { flag: 'es', language: 'es', title: 'Español' },
      ],
    };
  },
  mounted() {
    console.log(getUserCountry().id);
  },
  methods: {
    changeLocale() {
      this.$data.currentLang = this.currentLang == 'es' ? 'en' : 'es';
      // this.$data.currentFlag = this.currentFlag == 'es' ? 'us' : 'es';
      i18n.locale = this.currentLang;
    },
  },
};
</script>

<style></style>
